goog.provide("shadow.js.shim.module$date_fns$add$default");
shadow.js.shim.module$date_fns$add$default = shadow.js.require(132, {})["default"];
